import { adminBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";

export const skuDocApi = createApi({
  reducerPath: "skuDocApi",
  baseQuery: adminBaseQueryWrapper,
  tagTypes: ["skuDoc"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    uploadSkuDocument: builder.mutation<
      any,
      { file: File; company_id: number }
    >({
      query: ({ file, company_id }) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("company_id", company_id.toString());
        return {
          url: `/sku/upload-skus`,
          method: "POST",
          body: formData,
        };
      },
    }),
    SkuFileValidate: builder.query({
      query: ({ document_id, company_id }) => ({
        url: `/sku/validation/validate-skus`,
        params: { document_id, company_id },
      }),
    }),
    SkuFileValidateJson: builder.mutation({
      query: ({ records }) => ({
        url: `/sku/json/validate-json-skus`,
        method: "POST",
        body: { records },
      }),
    }),
    confirmSkuUpload: builder.mutation<any, { records: any[] }>({
      query: (body) => ({
        url: `/sku/confirm-skus`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useUploadSkuDocumentMutation,
  useLazySkuFileValidateQuery,
  useSkuFileValidateJsonMutation,
  useConfirmSkuUploadMutation,
} = skuDocApi;
